'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tethered = require('./tethered');

var _tethered2 = _interopRequireDefault(_tethered);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _tethered2['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/tethered/index.js
 ** module id = 775
 ** module chunks = 0 1
 **/